import styled from 'styled-components';
import Container from '../Container';
export const ImageStyled = styled('img')(() => ({
    objectFit: 'cover',
}));
export const PlaceholderWrapper = styled(Container)(({ height, width, }) => ({
    height,
    width,
}));
//# sourceMappingURL=Image.styles.js.map